<div class="modal" role="dialog" [ngStyle]="{'display': showModal ? 'block': 'none'}" id="search-modal">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Member details</h5>
        <button type="button" class="btn btn-close btn-outline-secondary" (click)="closeModal()">
        </button>
      </div>
      <div class="modal-body">
        @if (photo != '') {
          <div>
            <img src="{{photo}}">
          </div>
        }
        @if (name != '') {
          <div>
            Name: {{name}}
          </div>
        }
        @if (email != '') {
          <div>
            Email: {{email}}
          </div>
        }
      </div>
      <div class="modal-footer">
        <div class="btn-group" role="group" >
          <button type="button" class="btn btn-outline-secondary" (click)="removeUserFromWorkpackage()" tooltip="Remove user from task">
            <i class="bi bi-person-slash"></i>
          </button>
        </div>
      </div>
    </div>
  </div>
</div>